export const environment = {
  production: true,
  buildId: '3002222444819931',
  configFile: 'config.json',
};
